import React, { useEffect, Suspense, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import "bootstrap-icons/font/bootstrap-icons.css";
import { logout } from "./actions/auth";
import EventBus from "./utilities/EventBus";
import './assets/css/style.css'
import Routes from './components/routing/Routes';
import './config';
import Layout from './components/layout/Layout';


function App() {
  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
    const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [currentUser, logOut]);


  let isDefaultUrl = false;
   if(window.location.pathname === '/PMIS/' ||  window.location.pathname === '/PMIS/as' ) {
    isDefaultUrl=true;
   }
     return (
    <>
       <Suspense fallback={<div>Loading... </div>}>
        <Layout isLoggedIn={isLoggedIn} isDefaultUrl={isDefaultUrl}>
          {
            <Routes />
          }
        </Layout >
      </Suspense>
    </>



  )
}
export default App;


